export const TEAM_CREDIT_CURRENCIES = ["NPR", "USD", "USDT"];

export function fmtTeamCredit(value, currency = "USD") {
  const amount = Number(value || 0);
  const selectedCurrency = TEAM_CREDIT_CURRENCIES.includes(currency) ? currency : "USD";
  const precision = selectedCurrency === "USDT" ? 4 : 2;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(Number.isFinite(amount) ? amount : 0) + ` ${selectedCurrency}`;
}

export const fmtUSD = (value) => fmtTeamCredit(value, "USD");

